import React, {FC, useEffect, useMemo, useState} from 'react';
import {WinnerEntry} from "../../../util/hooks/useWishCountdown";
import {Theme} from "@mui/material/styles";
import {SxProps} from "@mui/system";
import {IWinnerTicket, IWish} from "../../../store/wish/Helper";
import WinnersButton from "./WinnersButton";
import WinnerDisplay from "./WinnerDisplay";
import {hasCompleteWinners} from "../../../util/winnerStatus";

interface IProps {
    thumbnail: string;
    tickets: WinnerEntry[];
    winners: IWinnerTicket[]
    color: string
    sx?: SxProps<Theme>
    wish?: IWish
    buttonColor?: "primary" | "secondary" | "tertiary"
    buttonSize?: "small" | "medium"
}

const CardWinnerPicker: FC<IProps> = ({buttonSize = "small", ...props}) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const winnersComplete = useMemo(() => (
        hasCompleteWinners(props.wish, props.winners)
    ), [props.wish, props.winners]);

    // Cycle through tickets before winners are announced
    useEffect(() => {
        if (winnersComplete || props.tickets.length === 0) return;

        const intervalId = setInterval(() => {
            setCurrentIndex(prevIndex => (prevIndex + 1) % props.tickets.length);
        }, 200);
        return () => clearInterval(intervalId);
    }, [props.tickets.length, winnersComplete]);

    const currentEntry = props.tickets.length > 0 ? props.tickets[currentIndex % props.tickets.length] : null;

    if (winnersComplete) {
        return (
            <WinnersButton
                wish={props.wish!}
                winners={props.winners}
                buttonColor={props.buttonColor}
                buttonSize={buttonSize}
            />
        );
    }

    return <WinnerDisplay entry={currentEntry} color={props.color} sx={props.sx}/>;
};

export default CardWinnerPicker;
